<template>
  <div v-if="isOpen" class="pricing">
    <div v-if="showBaseRate">
      <PmwParagraph size="paragraph-80" weight="light" class="pricing--title">
        Tarifa base
      </PmwParagraph>

      <PmwFormSelect
        v-model="selectedBaseRate"
        :options="ratesOptions"
        :toggleAll="false"
        label="Tarifa base"
        size="large"
        @input="selectHandler"
      />

      <SeparateLine :right="0" :left="0" />
    </div>

    <!-- CALENDÁRIO ABSOLUTO -->
    <div v-if="coefficientType === 1">
      <AbsoluteCalendar
        v-model="fluctuationData.precosQuartos"
        :allRooms="rooms"
        :selectedRooms="fluctuationData.quartos"
        @hasAllFields="hasAllFields"
      />

      <SeparateLine :right="0" :left="0" />
    </div>

    <!-- PENSÃO POR IDADE -->
    <PensionByAge :fluctuationData="fluctuationData" />

    <SeparateLine :right="0" :left="0" />

    <!-- VALORES POR ACOMODAÇÃO -->

    <div v-if="isRateAbsolute === false && coefficientType === 0">
      <AccomodationsValues
        :fluctuationData="fluctuationData"
        :hotelRoomsData="rooms"
        :isOpen="accomodationIsOpen"
        @close="accomodationIsOpen = false"
      />

      <SeparateLine :right="0" :left="0" />
    </div>

    <!-- PAX ADICIONAL -->
    <AdditionalPax
      v-if="isRateAbsolute === false && coefficientType === 0"
      :fluctuationData="fluctuationData"
      :hotelRoomsData="rooms"
      :isOpen="additionaPaxIsOpen"
      @close="additionaPaxIsOpen = false"
    />
  </div>
</template>

<script>
import AdditionalPax from '@/components/hotel/rateFluctuations/pricingConfiguration/AdditionalPax'
import AccomodationsValues from '@/components/hotel/rateFluctuations/pricingConfiguration/AccomodationsValues'
import PensionByAge from '@/components/hotel/rateFluctuations/pricingConfiguration/PensionByAge'
import AbsoluteCalendar from '@/components/hotel/masterRates/pricing/AbsoluteCalendar'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'

export default {
  name: 'Pricing',

  components: {
    AbsoluteCalendar,
    PensionByAge,
    AccomodationsValues,
    AdditionalPax,
    PmwFormSelect,
    PmwParagraph,
    SeparateLine
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => {}
    },

    rooms: {
      type: Array,
      default: () => []
    },

    coefficientType: {
      type: Number,
      default: 0
    },

    isOpen: {
      type: Boolean,
      default: false
    },

    isRateAbsolute: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      ratesOptions: [],

      selectedBaseRate: [],

      accomodationIsOpen: false,

      additionaPaxIsOpen: false
    }
  },

  computed: {
    /**
     * Exibe o seletor de tarifa base se a tarifa for absoluta E
     * se o coeficiente for flutuante E
     * se houver mais de uma opção de tarifa para seleção
     */
    showBaseRate() {
      return (
        this.isRateAbsolute === true &&
        this.coefficientType === 0 &&
        this.ratesOptions.length > 1
      )
    }
  },

  created() {
    this.getAbsoluteRates()
  },

  watch: {
    /**
     * Se houver apenas uma opção de tarifa base, seta ela como default
     * @param {array} newVal: opções de tarifa base
     */
    ratesOptions(newVal) {
      if (newVal.length === 1) {
        this.fluctuationData.codigoTarifaBase = newVal[0].value
      }
    },

    'fluctuationData.codigoTarifaBase': {
      handler(newVal) {
        this.selectedBaseRate = this.ratesOptions.find(
          (item) => item.value === newVal
        )
      },
      immediate: true
    },

    rooms: {
      handler(newVal) {
        if (newVal.length) {
          this.fluctuationData.quartos = []
          this.fluctuationData.quartos = newVal.map((item) => item.codigo)
        }
      },
      immediate: true
    },

    isOpen: {
      handler(newVal) {
        if (newVal === true) {
          this.accomodationIsOpen = true
          this.additionaPaxIsOpen = true
        }
      }
    }
  },

  methods: {
    /**
     * Emite o evento com os campos preenchidos
     * @param {boolean} event: se todos os campos do quarto estão preenchidos
     */
    hasAllFields(event) {
      this.$emit('hasAllFields', event)
    },

    /** Busca as tarifas absolutas */
    getAbsoluteRates() {
      this.$rate.getAbsoluteRates(this.$route.params.id).then((response) => {
        this.ratesOptions = response.data.map((item) => {
          return {
            text: item.nome,
            value: item.codigo
          }
        })
      })
    },

    /**
     * Passa a tarifa base selecionada para o fluctuationData
     * @param {object} selecedValue: item selecionado
     */
    selectHandler(selectedValue) {
      this.fluctuationData.codigoTarifaBase = selectedValue.value
    }
  }
}
</script>

<style lang="scss" scoped>
.pricing {
  &--title {
    margin: 25px 0 35px;
  }
}
</style>
